




import { computed, defineComponent } from '@nuxtjs/composition-api'
import SupportingData, { SupportingDataProp } from './SupportingData.vue'
import { MappedProduct } from '~/types/product/productTypes'
import { PRODUCT_TYPES } from '~/common/utils/product/constants'
import {
  DatasheetProductAttribute,
  DATASHEET_PRODUCT_ATTRIBUTES,
  getDatasheetProductAttributes,
} from '~/common/utils/datasheet/datasheetProductAttributeMapper'

export default defineComponent({
  components: {
    SupportingData,
  },
  props: {
    product: {
      type: Object as () => MappedProduct,
      required: true,
    },
  },
  setup(props) {
    const supportingData = computed<SupportingDataProp[]>(() => {
      const productType = props.product.productType
      if (
        ![
          PRODUCT_TYPES.FAST_SCAN_ELISA_KIT,
          PRODUCT_TYPES.MATCHED_ANTIBODY_PAIR,
          PRODUCT_TYPES.ELISA_KIT,
          PRODUCT_TYPES.ELISA_ANTIBODY_PAIR,
          PRODUCT_TYPES.OLIGO_ANTIBODY_PAIR,
          PRODUCT_TYPES.CELLULAR_DYES,
          PRODUCT_TYPES.PROTEIN_CONTROL,
        ].includes(productType)
      ) {
        return [] // don't show any supporting data
      }
      const attributes: DatasheetProductAttribute[] = []

      if (productType === PRODUCT_TYPES.CELLULAR_DYES) {
        attributes.push(DATASHEET_PRODUCT_ATTRIBUTES.APPLICATIONS)
      }

      if (productType === PRODUCT_TYPES.PROTEIN_CONTROL) {
        attributes.push(DATASHEET_PRODUCT_ATTRIBUTES.OBSERVED_MOLECULAR_WEIGHT)
      }

      if (productType !== PRODUCT_TYPES.OLIGO_ANTIBODY_PAIR || productType !== PRODUCT_TYPES.PROTEIN_CONTROL) {
        attributes.push(DATASHEET_PRODUCT_ATTRIBUTES.SPECIES_CROSS_REACTIVITY)
      }

      if (productType !== PRODUCT_TYPES.PROTEIN_CONTROL) {
        attributes.push(DATASHEET_PRODUCT_ATTRIBUTES.UNI_PROT_ID, DATASHEET_PRODUCT_ATTRIBUTES.ENTREZ_GENE_ID_HASHTAG)
      }

      return getDatasheetProductAttributes(props.product, attributes)
        .filter((x) => !!x.value?.trim()) // remove empty values
        .map((x) => ({ key: x.label, value: x.value! }))
    })

    return {
      supportingData,
    }
  },
})
